import consumerApi from "api/services/consumer-api";
import { Coordinates } from "custom-types/Coordinates";
import { ApiResponse } from "custom-types/Deals";
import { stringify } from "qs";
import shuffle from "lodash/shuffle";

export const getDeals = async (
  coordinates: Coordinates,
  countryCode = "US",
  skip = 0,
  take = 6,
  randomize = false
) => {
  const route = "/api/menu_deals/v1/search";
  const body = stringify(
    {
      ...coordinates,
      "filter[active]": true,
      "sort[0][distance]": "asc",
      skip,
      take,
    },
    {
      arrayFormat: "brackets",
      encodeValuesOnly: true,
    }
  );

  try {
    const {
      data: {
        data,
        metadata: { availableFilters },
      },
    } = await consumerApi.get<ApiResponse>(`${route}?${body}`, {
      headers: {
        "x-country-code": countryCode,
      },
    });

    const dealCategories =
      availableFilters
        .find((filter) => filter.key === "categories")
        ?.options?.map((category) => category.key) || [];

    return { deals: randomize ? shuffle(data) : data, dealCategories };
  } catch {
    return { deals: [], dealCategories: [] };
  }
};
